import { Link } from 'react-router-dom';
import Eyebrow from '@/components/base/Eyebrow';

const steps = [
  { title: 'Understand the challenge.', copy: 'We start with listening — to leadership, to teams and to the context behind the brief.' },
  { title: 'Define the approach.', copy: 'Together we agree scope, priorities and what a good outcome genuinely looks like.' },
  { title: 'Work in partnership.', copy: 'We stay close and candid, sharing progress openly and adapting as things evolve.' },
  { title: 'Support meaningful outcomes.', copy: 'Our involvement continues beyond the decision, helping people and changes settle well.' },
];

export default function ProcessAndCta() {
  return (
    <>
      <section className="bg-white py-20 md:py-28">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div data-reveal className="lg:col-span-4">
              <Eyebrow>OUR PROCESS</Eyebrow>
              <h2 className="mt-6 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em] text-foreground-950">
                Built around your needs, not a fixed formula.
              </h2>
            </div>
            <ol data-reveal-stagger className="lg:col-span-7 lg:col-start-6 border-t border-foreground-950/15">
              {steps.map((s, i) => (
                <li key={s.title} className="grid grid-cols-[44px_1fr] md:grid-cols-[64px_1fr_1fr] gap-x-4 md:gap-x-8 gap-y-2 py-6 md:py-8 border-b border-foreground-950/15">
                  <span className="font-label text-[13px] tracking-[0.12em] text-accent-600 pt-1.5">0{i + 1}</span>
                  <h3 className="font-heading text-[22px] md:text-[24px] leading-tight text-foreground-950">{s.title}</h3>
                  <p className="col-start-2 md:col-start-3 text-[15px] leading-[1.6] text-foreground-700">{s.copy}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>

      <section className="bg-white pb-20 md:pb-28">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-8 items-end border-t border-foreground-950/15 pt-16 md:pt-20">
            <h2 className="lg:col-span-7 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em] text-foreground-950">
              Every meaningful partnership starts with a conversation.
            </h2>
            <div className="lg:col-span-4 lg:col-start-9">
              <p className="text-[16px] leading-[1.6] text-foreground-700">
                Tell us what you&apos;re working towards. We&apos;ll explore how we can help.
              </p>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-1 text-[15px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap hover:text-accent-600 hover:border-accent-500 transition-colors duration-200 ease-ui focus-ring cursor-pointer group"
              >
                Discuss your needs <i className="ri-arrow-right-up-line arrow-nudge"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}